var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContactusbg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1440 320",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#e8f9ff",
    fillOpacity: 1,
    d: "M0,192L34.3,213.3C68.6,235,137,277,206,245.3C274.3,213,343,107,411,80C480,53,549,107,617,112C685.7,117,754,75,823,64C891.4,53,960,75,1029,80C1097.1,85,1166,75,1234,106.7C1302.9,139,1371,213,1406,250.7L1440,288L1440,0L1405.7,0C1371.4,0,1303,0,1234,0C1165.7,0,1097,0,1029,0C960,0,891,0,823,0C754.3,0,686,0,617,0C548.6,0,480,0,411,0C342.9,0,274,0,206,0C137.1,0,69,0,34,0L0,0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactusbg);
export default __webpack_public_path__ + "static/media/contactusbg.3e31ae4cca9628db8bc60fe32def7862.svg";
export { ForwardRef as ReactComponent };